import { render, staticRenderFns } from "./SortableColumn.vue?vue&type=template&id=3577216e"
import script from "./SortableColumn.vue?vue&type=script&lang=js"
export * from "./SortableColumn.vue?vue&type=script&lang=js"
import style0 from "./SortableColumn.vue?vue&type=style&index=0&id=3577216e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports